var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.993 10.736L27.79 27.37 9.44 30.044l13.285 12.94-3.128 18.28 16.412-8.636 16.419 8.623-3.142-18.277 13.276-12.95-18.354-2.66-8.214-16.628z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M35.993 10.736L27.79 27.37 9.44 30.044l13.285 12.94-3.128 18.28 16.412-8.636 16.419 8.623-3.142-18.277 13.276-12.95-18.354-2.66-8.214-16.628z"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzIgNzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM1Ljk5MyAxMC43MzYgMjcuNzkgMjcuMzcgOS40NCAzMC4wNDRsMTMuMjg1IDEyLjk0LTMuMTI4IDE4LjI4IDE2LjQxMi04LjYzNiAxNi40MTkgOC42MjMtMy4xNDItMTguMjc3IDEzLjI3Ni0xMi45NS0xOC4zNTQtMi42Ni04LjIxNC0xNi42Mjh6Ii8+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMzUuOTkzIDEwLjczNiAyNy43OSAyNy4zNyA5LjQ0IDMwLjA0NGwxMy4yODUgMTIuOTQtMy4xMjggMTguMjggMTYuNDEyLTguNjM2IDE2LjQxOSA4LjYyMy0zLjE0Mi0xOC4yNzcgMTMuMjc2LTEyLjk1LTE4LjM1NC0yLjY2LTguMjE0LTE2LjYyOHoiLz48L3N2Zz4=";
export { SvgStar as ReactComponent };